var SchedulingFrequency;
(function (SchedulingFrequency) {
    SchedulingFrequency["Manual"] = "NONE";
    SchedulingFrequency["Hours"] = "HOUR";
    SchedulingFrequency["Days"] = "DAY";
    SchedulingFrequency["Weeks"] = "WEEK";
})(SchedulingFrequency || (SchedulingFrequency = {}));
export default SchedulingFrequency;
